import styled from "styled-components";
import { media } from "../../styles/breakpoints";
import { primaryFontFamily } from "../../styles/fontFamilyTypes";
import { neutral8, neutral7, neutral3, neutral5, tertiarywarning, } from "../../css/colors";
import { LineClamp } from "../../styles/mixins";
export const Comma = styled.div `
  .icon {
    width: 27.3px;
    height: 22.7px;
    margin: 10px;
  }
`;
export const ClosingQuote = styled.div `
  display: flex;
  justify-content: flex-end;
  padding: 10px;
`;
export const CardConatiner = styled.div `
  border-radius: 9px;
  border: dashed 2px ${neutral3};
  margin: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  > div:first-child: {
    margin-left: 0px;
  }
  > div:last-child: {
    margin-right: 0px;
  }
  @media ${media.medium.down} {
    margin: 0px 10px 10px;
  }
`;
export const Description = styled.div `
  font-family: ${primaryFontFamily};
  font-size: 22px;
  font-style: italic;
  line-height: 1.51;
  letter-spacing: normal;
  text-align: center;
  color: ${neutral8};
  margin: 0px 42px 42px;
  ${LineClamp(5)}
  @media ${media.medium.down} {
    font-size: 16px;
    line-height: 1.74;
  }
`;
export const Author = styled.div `
  font-family: ${primaryFontFamily};
  font-size: 18px;
  text-align: left;
  color: ${neutral7};
  display: flex;
  justify-content: center;
  padding-right: 10px;
  @media ${media.medium.down} {
    font-size: 15px;
  }
`;
export const RatingWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const active = styled.div `
  display: inline-block;
  padding: 3px;
  vertical-align: middle;
  line-height: 1;
  font-size: 1.5em;
  color: ${neutral5};
`;
export const inactive = styled.div `
  color: ${tertiarywarning};
  display: inline-block;
  padding: 3px;
  vertical-align: middle;
  line-height: 1;
  font-size: 1.5em;
`;
export const Rating = styled.div `
  display: inline-block;
  padding: 3px;
  vertical-align: middle;
  line-height: 1;
  font-size: 1.5em;
  .active {
    color: ${tertiarywarning};
  }
  .inactive {
    color: ${neutral5};
  }
`;
export const CardWrapper = styled.div `
  display: flex;
`;
export const Container = styled.div `
  position: relative;
  .goToPrev,
  .goToNext {
    opacity: 0.8;
    pointer-events: all;
    transform: scale(1.001) translateY(-50%);
    transform-origin: top;
    transition:
      opacity 0.2s ease-in-out,
      transform 0.2s ease-in-out;
    height: 2vw;
    width: 2vw;
    display: flex;

    @media only screen and (max-width: 1023px) {
      height: 4vw;
      width: 4vw;
    }

    &:hover {
      opacity: 1;
      transform: scale(1.1) translateY(-50%);
    }
  }

  .goToPrev {
    left: -2vw;

    @media only screen and (max-width: 1023px) {
      left: -2vw;
    }
  }

  .goToNext {
    right: -2vw;
    @media only screen and (max-width: 1023px) {
      right: -2vw;
    }
  }
`;
export const RailWrapper = styled.div `
  display: flex;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
    scrollbar-width: none;
  }
`;
export const SilderContainer = styled.div `
  display: flex;
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
export const Wrapper = styled.div `
  width: auto;
`;

